module.exports = __webpack_public_path__ + "assets/img/IMG028.c4597b72.png";